import { Component } from '@angular/core';
import { ProductIntroComponent } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-product-intro',
    templateUrl: './efa-product-intro.component.html',
    imports: [AsyncPipe, TranslatePipe]
})
export class EfaProductIntroComponent extends ProductIntroComponent {

}
